import PageBanner from "app/components/ui/PageBanner"
import HelmetTitle from "app/meta/HelmetTitle"
import React from 'react'
import './styles/ServicesPage.css'
import MakeAppointment from "app/components/homepage/MakeAppointment"
import PageSection from "app/components/ui/PageSection"
import sectionImg1 from 'app/assets/images/womens-health-1.jpg'
import SiteGrid from "app/components/ui/SiteGrid"
import { womensHealthData } from "app/data/servicesData"
import IconsBarSection from "app/components/ui/IconsBarSection"

export default function WomensHealthPage() {

  return (
    <div className="womens-health-page services-page">
      <HelmetTitle title="Women's Health" />
      <PageBanner
        title="Women's Health"
        subtitle="At Aphrodite, we supporting Women's Physical and Mental Health with Evidence-Based Information"
      />
      <div className="page-content">
        <PageSection
          subtitle="Health and Wellness"
          title="Empowering Women to Prioritize Their Health"
          text={<p>
            At Aphrodite, our healthcare center, we understand that women's health is a
            complex and multifaceted issue that requires specialized care. That's why we
            offer a comprehensive range of services to support women's health and
            wellness at all stages of life.
            <br /><br />
            Whether you are in need of routine check-ups, specialized care, or support
            for a specific health concern, we are here to help. We believe that by
            providing comprehensive women's health services, we can help women lead
            healthy and fulfilling lives.
          </p>}
          img={sectionImg1}
        />
        <SiteGrid className="section section-2">
          <h5>Investing in Women's Health</h5>
          <h2>Our Commitment to<br/>Comprehensive and Personalized Care</h2>
          <div className="video-container">
            <iframe
              src="https://www.youtube.com/embed/RzVvThhjAKw"
              title="Nature Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </SiteGrid>
        <SiteGrid className="section section-3">
          <IconsBarSection
            title="Specialized Services we offer"
            subtitle="Women's Health Services"
            data={womensHealthData}
          />
        </SiteGrid>
        <MakeAppointment />
      </div>
    </div>
  )
}
